import { render } from "./App.vue?vue&type=template&id=7c5a9307"
const script = {}

import exportComponent from "/Users/hokada/develop/src/github.com/ocadaruma/pete2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__